import { useEffect, useState } from 'react';

/** Below this view width the right sidebar floats over the view. */
export const RESPONSIVE_SIDEBAR_FLOAT_THRESHOLD = 900;

const SIDEBAR_FLOAT_QUERY = `(max-width: ${RESPONSIVE_SIDEBAR_FLOAT_THRESHOLD}px)`;

/**
 * Below the float threshold the right sidebar floats over the view instead of
 * docking beside it, and a split view has no room.
 */
export function useSidebarFloats(): boolean {
  const [floats, setFloats] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia(SIDEBAR_FLOAT_QUERY).matches
  );
  useEffect(() => {
    const query = window.matchMedia(SIDEBAR_FLOAT_QUERY);
    const onChange = () => setFloats(query.matches);
    onChange();
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return floats;
}
